import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AppDispatch, RootState } from '@redux/store';

export const useDispatch = useReduxDispatch<AppDispatch>;
export const useSelector = <T>(fc) => useReduxSelector<RootState, T>(fc);
